export const api = {
  headers() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
        ?.content,
    };
  },

  async get(url, options = {}) {
    return await this.request("GET", url, options);
  },

  async post(url, data, options = {}) {
    return await this.request("POST", url, { ...options, data });
  },

  async put(url, data, options = {}) {
    return await this.request("PUT", url, { ...options, data });
  },

  async delete(url, options = {}) {
    return await this.request("DELETE", url, options);
  },

  async request(method, url, { data, headers = {}, signal, ...options } = {}) {
    const controller = signal?.controller || new AbortController();
    const abortSignal = signal || controller.signal;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          ...this.headers(),
          ...headers,
        },
        ...(data && { body: JSON.stringify(data) }),
        signal: abortSignal,
        ...options,
      });

      if (!response.ok) {
        // Handle different error status codes if needed
        const error = await response.json();
        console.log("API Error:", error);
        throw new Error(error.errors || "API request failed");
      }

      // Only try to parse JSON if there's content
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        return await response.json();
      }

      return response;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  },

  async uploadFiles(url, files, extraData = {}) {
    const formData = new FormData();

    // Add any extra data fields
    Object.entries(extraData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // Add files
    if (Array.isArray(files)) {
      files.forEach((file) => {
        formData.append("images[]", file);
      });
    } else {
      formData.append("images[]", files);
    }

    return await fetch(url, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
      body: formData,
    }).then((response) => {
      if (!response.ok) {
        throw new Error("Upload failed");
      } else {
        response.text().then((html) => Turbo.renderStreamMessage(html));
      }
    });
  },
};
